import {
  PLATFORM_ACCESS,
  PLATFORM_TENANT_VIEW,
  PLATFORM_USER_VIEW,
  PLATFORM_JOB_VIEW,
  PLATFORM_WORKER_VIEW,
  PLATFORM_POLICY_VIEW,
  PLATFORM_AUDIT_VIEW,
  PLATFORM_SETTINGS_VIEW,
} from '../auth/permissions';

export const platformNavItems = [
  { label: 'Overview', path: '/platform', permission: PLATFORM_ACCESS, end: true },
  { label: 'Partners', path: '/platform/partners', permission: PLATFORM_TENANT_VIEW },
  { label: 'Users', path: '/platform/users', permission: PLATFORM_USER_VIEW },
  { label: 'Team', path: '/platform/team', permission: PLATFORM_USER_VIEW },
  { label: 'Jobs', path: '/platform/jobs', permission: PLATFORM_JOB_VIEW },
  { label: 'Workers', path: '/platform/workers', permission: PLATFORM_WORKER_VIEW },
  { label: 'Policies', path: '/platform/policies', permission: PLATFORM_POLICY_VIEW },
  { label: 'Audit', path: '/platform/audit', permission: PLATFORM_AUDIT_VIEW },
  { label: 'Settings', path: '/platform/settings', permission: PLATFORM_SETTINGS_VIEW },
];

export function filterPlatformNavByPermission(items, hasPlatformPermission) {
  return items.filter((item) => {
    if (!item.permission) return true;
    return hasPlatformPermission(item.permission);
  });
}

export default platformNavItems;
